export default __webpack_public_path__ + "static/media/bio.c7a1886a.jpg";